import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=ef66c094"
import script from "./AlertView.vue?vue&type=script&lang=js"
export * from "./AlertView.vue?vue&type=script&lang=js"
import style0 from "./AlertView.vue?vue&type=style&index=0&id=ef66c094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports